import { useState } from "react";
import useDashboardProducts, {
  DashboardProductType,
} from "./useDashboardProducts";

/**
 * The dashboard's selected product tab (r-1776): the first active paid
 * product by default, until the user picks another tab. Lives outside
 * `DashboardProductNavigation` so the page can also react to the selection
 * (the shared Setup Guides / AI agent banner only accompany an active
 * product). `initialProductType` overrides the default (used by stories).
 */
export default function useDashboardProductSelection(
  initialProductType?: DashboardProductType
) {
  const { products, isLoading, defaultProductType } = useDashboardProducts();

  const [selected, setSelected] = useState<DashboardProductType | undefined>(
    initialProductType
  );
  const selectedType = selected ?? defaultProductType;
  const selectedProduct = products.find((p) => p.type === selectedType);

  return { products, isLoading, selectedType, selectedProduct, setSelected };
}

export type DashboardProductSelection = ReturnType<
  typeof useDashboardProductSelection
>;
